// 會籍徽章
// binary 結構（2026-05-23 對齊客戶 docx;顯示名 2026-06-17 對齊客戶定稿,enum code 不動）:
//   general          — 霽雲薈(LINE 加好友 default,無付費)
//   health_affiliate — 潤雲薈(中階;code 沿用,內含醫療「內在微平衡」$1,980)
//   timeless_club    — 恆時薈(頂級,4 大權益)

type Tier = "general" | "health_affiliate" | "timeless_club";

const TIER_LABEL: Record<Tier, string> = {
  general: "霽雲薈",
  health_affiliate: "潤雲薈",
  timeless_club: "恆時薈",
};

const TIER_BG: Record<Tier, string> = {
  general: "bg-tier-general",
  health_affiliate: "bg-tier-health",
  timeless_club: "bg-tier-timeless",
};

export default function TierBadge({
  tier,
  size = "md",
}: {
  tier: Tier;
  size?: "sm" | "md" | "lg";
}) {
  const sizeCls =
    size === "sm"
      ? "px-2 py-0.5 text-xs"
      : size === "lg"
        ? "px-4 py-1.5 text-base"
        : "px-3 py-1 text-sm";

  // general 用淺色背景 + 深字,health/timeless 用深底白字
  const textColorCls = tier === "general" ? "text-charcoal" : "text-white";
  // general 淺底徽章在白底頁面邊界會糊,加一道淡邊框
  const borderCls = tier === "general" ? "border border-sage" : "";

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${TIER_BG[tier]} ${textColorCls} ${borderCls} ${sizeCls}`}
    >
      {TIER_LABEL[tier]}
    </span>
  );
}

export { TIER_LABEL };
export type { Tier };
